// extracted by mini-css-extract-plugin
export default {"container":"Side_container__ZaoZc","mainBtn":"Side_mainBtn__54-Wa","menus":"Side_menus__pNSP9","submenu":"Side_submenu__4V5-L","open":"Side_open__fQf63"};